import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/console.css';
import './styles/app.css';
import './styles/entry.css';
import { App } from './App';
import { TipProvider } from './components/Tip';
import { ToastProvider } from './components/Toast';
import { applyTheme, readTheme } from './lib/theme';
import { LANG } from './lib/strings';
import { Crash } from './components/Crash';

// Before the first paint, so the sign-in never flashes dark on a dark Mac.
applyTheme(readTheme());
document.documentElement.lang = LANG;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <TipProvider>
        <Crash><App /></Crash>
      </TipProvider>
    </ToastProvider>
  </StrictMode>,
);
